import { questionGroupKeyRegex } from './translation-key.constant';
import { TranslationRow } from './translation-row.model';

export class TranslationGroup {
  public isQuestionGroup: boolean;
  public isIgnored: boolean;
  public hasIgnoredEntries: boolean;

  constructor(
    public groupKey: string,
    public readonly name: string,
    public rows: TranslationRow[]
  ) {
    this.isQuestionGroup = questionGroupKeyRegex.test(groupKey);
    this.isIgnored = rows.length > 0 && rows.every((row) => row.translatedEntry?.ignoredInd === true);
    this.hasIgnoredEntries = rows.some((row) => row.translatedEntry?.ignoredInd === true);
  }
}

export interface TranslationGroupConfig {
  key: string;
  name: string;
}
